import React from 'react';

/**
 * Async (code-split) entry point for RovoFullPageSpotlightPlacement.
 *
 * Use this instead of the synchronous import to keep the Post Office headless
 * API and spotlight UI out of the main nav bundle. The chunk is only fetched
 * when the feature gate `rovo_chat_full_page_chat_spotlight` is enabled.
 */
export const AsyncRovoFullPageSpotlightPlacement: React.LazyExoticComponent<
	typeof import('./RovoFullPageSpotlightPlacement').RovoFullPageSpotlightPlacement
> = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-onboarding/rovo-full-page-spotlight" */
		'./RovoFullPageSpotlightPlacement'
	).then(({ RovoFullPageSpotlightPlacement }) => ({ default: RovoFullPageSpotlightPlacement })),
);

(
	AsyncRovoFullPageSpotlightPlacement as React.ComponentType<
		React.ComponentProps<
			typeof import('./RovoFullPageSpotlightPlacement').RovoFullPageSpotlightPlacement
		>
	>
).displayName = 'AsyncRovoFullPageSpotlightPlacement';
